
import { initialCursorState } from '../../reducers/ui/cursorTables';

// Singleton estable para claves desconocidas (evita re-renders por nueva ref).
const EMPTY_CURSOR: Record<string, never> = {};

export const getCursor = (namingForm: string) => (state: any) => {
  // Fallback al default del reducer cuando la clave NO existe en el estado
  // persistido. redux-persist (autoMergeLevel1, sin migración ni stateReconciler)
  // rehidrata un `cursorTables` que puede NO incluir tableIds añadidos después de
  // que el usuario guardara su estado en localStorage. Sin este fallback,
  // getCursor devolvería `undefined` y cualquier loader/tabla que lea
  // `cursor.<campo>` (p.ej. `concessionId`) crashea. El reducer ya define el
  // cursor por defecto de cada tableId en `initialCursorState`.
  // (Fix portado de main 2026-07-04 — el merge lo dejó atrás en la rama SR.)
  return (
    state.cursorTables?.[namingForm] ??
    (initialCursorState as Record<string, any>)[namingForm] ??
    EMPTY_CURSOR
  );
};


export const getTableCurrentPage = (tableId: string) => (state: any) => {
  return state.tablePages[tableId] as number | undefined;
};



export const getTake = () => (state: any) => {
  return state.takeTables;
};

 
export const getIsLoadingData = (namingForm: string) => (state: any) => {
  return state.loadingData[namingForm]?.isLoadingData;
};
